<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2><a href="#/admin">{{$t('admin.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{$t('admin.appliances.title')}}</h2>
        <div class="irinox-form" >

          <div class="search-bar" style="float: right">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('admin.appliances.search')" :aria-label="$t('admin.appliances.search')"/>
            <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
          </div>
          <div class="p-formgroup-inline p-ai-center">
            <div class="p-field">
              <span class="admin-user-email">{{email}}</span>
            </div>
            <div class="p-field">
              <Dropdown id="modelNumber" v-model="filters['modelNumber'].value" :options="modelNumbers" optionLabel="name" optionValue="code"
                :placeholder="$t('admin.appliances.filter_model_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="labName" v-model="filters['labName'].value" :options="laboratories" optionLabel="name" optionValue="code"
                :placeholder="$t('admin.appliances.filter_lab_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="role" v-model="filters['role'].value" :options="roles" optionLabel="name" optionValue="code"
                :placeholder="$t('admin.appliances.filter_role_ph')" />
            </div>
            <div class="p-field">
              <ToggleButton v-model="statusButton" :onLabel="$t('admin.appliances.filter_online')" :offLabel="$t('admin.appliances.filter_online')"  :aria-label="$t('common.online')+'/'+$t('common.offline')"/>      
            </div>
          </div>

          <div class="display-when-breakpoint">
            <span class="button-header" @click="openAddDialog"><i class="pi pi-plus" /> {{$t('admin.appliances.col_addappliance')}}</span>
          </div>

          <DataTable :value="appliances" v-model:selection="selectedAppliances" stripedRows 
            v-model:filters="filters" responsiveLayout="stack" dataKey="serialNumber" 
            breakpoint="960px">
            <template #empty>
                {{$t('admin.appliances.empty_list')}}
            </template>
            <template #loading>
                {{$t('admin.appliances.loading_list')}}
            </template>

            <Column field="serialNumber" :header="$t('admin.appliances.col_serialnumber')" ></Column>

            <Column field="modelNumber" :header="$t('admin.appliances.col_model')" >
              <template #body="slotProps">
                <div>
                  {{$functions.fixModelName(slotProps.data.modelNumber)}} 
                  <img v-if="slotProps.data.online" src="assets/irinox/icons/status_online_small.svg" class="p-pl-1"  :alt="$t('common.online')"/>
                  <img v-else src="assets/irinox/icons/status_offline_small.svg" class="p-pl-1" :alt="$t('common.offline')" />
                </div>
              </template>
            </Column>

            <Column field="name" :header="$t('admin.appliances.col_name')" >
              <template #body="slotProps">
                <div>
                  {{slotProps.data.name ?? slotProps.data.modelNumber}}
                </div>
              </template>
            </Column>

            <Column field="labName" :header="$t('admin.appliances.col_lab')" ></Column>

            <Column field="role" :header="$t('admin.appliances.col_role')" style="width: 165px">
              <template #body="slotProps">
                <span v-if="slotProps.data.role=='ADMIN'">{{$t('roles.ADMIN')}}</span>
                <span v-else-if="slotProps.data.role=='KITCHEN_MANAGER'">{{$t('roles.KITCHEN_MANAGER')}}</span>
                <span v-else-if="slotProps.data.role.includes('SERVICE')">{{$t('roles.SERVICE')}}</span>
                <span v-else>-</span>
              </template>
            </Column>

            <Column bodyClass="" class="irinox-table-buttons p-text-right">
              <template #header>
                <span class="button-header" @click="openAddDialog"><i class="pi pi-plus" /> {{$t('admin.appliances.col_addappliance')}}</span>
              </template>
              <template #body="slotProps">
                <div class="button-body">
                  <img src="assets/irinox/icons/delete.svg" @click="openDeleteDialog(slotProps.data.serialNumber)" v-tooltip.left="$t('admin.appliances.tooltip_delete')" :alt="$t('admin.appliances.tooltip_delete')"/>
                </div>
              </template>
            </Column>
          </DataTable>

        </div>
		</div>
	</div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="errorDialog" 
    mode="error" 
    :message="$t('admin.appliances.error_dialog')"
    :life="3000" 
    @update:visible="errorDialog = $event" />
  <IrinoxDialogDark :visible="expiredDialog" 
    mode="error" 
    :message="$t('admin.appliances.expired_dialog')"
    :life="3000" 
    @update:visible="expiredDialog = $event" />
  <IrinoxDialogDark :visible="blockingErrorDialog" 
    mode="error" 
    :message="$t('admin.appliances.error_dialog')"
    :life="0" 
    @update:visible="blockingErrorDialog = $event" />

  <!--               -->
  <!-- DELETE DIALOG -->
  <!--               -->
  <IrinoxDialogDark :visible="deleteDialog" 
    mode="confirm" 
    :leftB="$t('admin.appliances.delete_dialog_cancel_button')" 
    @click:left-button="()=>{deleteDialog=!deleteDialog}" 
    :rightB="$t('admin.appliances.delete_dialog_ok_button')" 
    @click:right-button="deleteAppliance" 
    :message="$t('admin.appliances.delete_dialog')"
    icon="assets/irinox/icons/delete_big.svg" />
  <IrinoxDialogDark :visible="successDeleteDialog" 
    mode="success" 
    :message="$t('admin.appliances.delete_dialog_success')"
    :life="3000" 
    @update:visible="successDeleteDialog = $event" />

  <!--              -->
  <!-- SHARE DIALOG -->
  <!--              -->
  <ShareAppliancesDialog :visible="shareDialog" 
    :preselectedAppliances="selectedAppliances"
    @update:visible="closeShareDialog"
    @click:left-button="closeShareDialog" 
    @click:right-button="closeShareDialog"/>

  <!--            -->
  <!-- ADD DIALOG -->
  <!--            -->
  <ShareDialog :visible="addDialog" 
    mode="user"
    :appliances="selectedAppliances"
    :email="email"
    @update:visible="addDialog = $event" 
    @click:button="addShare" 
    @click:open-share="openShareDialog"/>
  <IrinoxDialogDark :visible="successAddDialog" 
    mode="success" 
    :message="$t('admin.users.add_dialog_success_edit')"
    :life="3000" 
    @update:visible="successAddDialog = $event" />

</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import ShareDialog from '../ShareDialog.vue';
import ShareAppliancesDialog from '../ShareAppliancesDialog.vue';
import {FilterMatchMode} from 'primevue/api';

export default {
    components: {
        IrinoxDialogDark,
        ShareDialog,
        ShareAppliancesDialog,
    },
    data() {
        return {
          email: this.$route.params.email,
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
              'labName': {value: null, matchMode: FilterMatchMode.EQUALS},
              'role': {value: null, matchMode: FilterMatchMode.EQUALS},
              'online': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          appliances: [],
          selectedAppliances: [],
          serialNumber: null,
          modelNumbers: [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            }],
          laboratories: [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            }],
          roles: [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            },{
              code: "ADMIN",
              name: this.$t('roles.ADMIN')
            },{
              code: "KITCHEN_MANAGER",
              name: this.$t('roles.KITCHEN_MANAGER')
            },{
              code: "SERVICE",
              name: this.$t('roles.SERVICE')
            }],
          statusButton: false,
          errorDialog: false,
          blockingErrorDialog: false,
          expiredDialog: false,
          addDialog: false,
          successAddDialog: false,
          deleteDialog: false,
          successDeleteDialog: false,
          shareDialog: false,
        };
    },
    computed: {
        personaltoken: function() {
            return this.$store.getters['userdata/personaltoken'];
        },
    },
    watch: {
      statusButton: 'statusButtonToggle'
    },
    created() {
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.reloadAppliances();
    },
    methods: {
      reloadAppliances() {
        this.applianceService.getAdminAppliances(this.personaltoken, this.email)
          .then((appliances) => {
            this.appliances = appliances;
            let mns = [];
            let ls = [];
            for(let i=0; i<this.appliances.length; i++) {
              mns.push({ code: this.appliances[i].modelNumber, name: this.$functions.fixModelName(this.appliances[i].modelNumber) });
              if(this.appliances[i].labName) {
                ls.push({ code: this.appliances[i].labName, name: this.appliances[i].labName });
              }
            }
            this.modelNumbers = this.$functions.uniqByKeepFirst(mns, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
            this.modelNumbers.unshift({ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            });
            this.laboratories = this.$functions.uniqByKeepFirst(ls, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
            this.laboratories.unshift({ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            })
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.appliances = [];
          });
      },
      statusButtonToggle() {
        if(this.statusButton) {
          this.filters['online'].value = true;
        } else {
          this.filters['online'].value = null;
        }
      },
      openAddDialog() {
        this.selectedAppliances = [];
        this.addDialog = true;
      },
      openShareDialog() {
        this.addDialog = false;
        this.shareDialog = true;
      },
      closeShareDialog(appliances) {
        if(appliances) {
          this.selectedAppliances = appliances;
        }
        this.shareDialog = false;
        this.addDialog = true;
      },
      addShare(shareData) {

        shareData.appliances = [];
        for (let i = 0; i < this.selectedAppliances.length; i++) {
          shareData.appliances.push(this.selectedAppliances[i].serialNumber);
        }

        this.addDialog = false;

        this.applianceService.postAdminShare(this.personaltoken, shareData)
          .then((data) => {
            if(data.code == "200") {
              this.successAddDialog = true;
              this.reloadAppliances();
            } else if(data.code == "532") {
              this.expiredDialog = true;
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.errorDialog = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });

      },
      openDeleteDialog(serialNumber) {
        this.serialNumber = serialNumber;
        this.deleteDialog = true;
      },
      deleteAppliance() {
        this.deleteDialog = false;
        this.applianceService.deleteAdminShare(this.personaltoken, this.email, this.serialNumber)
          .then((data) => {
              if(data.code == "200") {
              this.successDeleteDialog = true;
              this.appliances = this.appliances.filter(function(val) {
                return val.serialNumber != this.serialNumber;
              }.bind(this));
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.errorDialog = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });
      },
    }
}
</script>

<style scoped>

.admin-user-email {
  color: #6B7280;
  font-size: 1rem;
  font-weight: 600;
}

.irinox-form .p-dropdown {
  width: 200px;
}



</style>